/* eslint-disable filename-rules/match */

import type { GetStaticProps } from 'next'

import { fallbackLng as defaultLocale } from '../../../next-i18next.config'

export { getStaticPaths } from './index'

import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import i18nextConfig from '../../../next-i18next.config'
import ArticlePage, { getStaticPropsWithOverwritablePath } from './index'

export default ArticlePage

export const getStaticProps: GetStaticProps = async ({ locale = defaultLocale, params }) =>
  serverSideTranslations(locale, ['common'], i18nextConfig).then(translations =>
    getStaticPropsWithOverwritablePath({ locale: locale.toLowerCase(), params }, translations, '/contentful')
  )
